module.exports = __webpack_public_path__ + "img/logo_lf.5d0102eb.png";